export default __webpack_public_path__ + "static/banner-0fe9d0faae1b17a793a3ae71dc971f2d.jpg";